import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { IAppState } from '@shared/models';
import { AppRoutesEnum } from '@shared/enums';
import { getIsBorrowerOrBroker } from '@features/auth/state/selectors';
import { waitUntilUserInitialized } from '@features/auth/utils';

@Injectable({
  providedIn: 'root',
})
export class NonLenderUserGuard {
  constructor(private readonly store$: Store<IAppState>, private readonly router: Router) {}

  public canActivateChild(): Observable<boolean> {
    return this.store$.pipe(
      waitUntilUserInitialized<IAppState>(this.store$),
      select(getIsBorrowerOrBroker),
      take(1),
      map((isBorrowerOrBrokerUser) => {
        if (!isBorrowerOrBrokerUser) {
          this.router.navigate([AppRoutesEnum.DEFAULT]);
          return false;
        }

        return true;
      })
    );
  }
}

export const canActivateNonLenderUser: CanActivateFn = () => inject(NonLenderUserGuard).canActivateChild();
